import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DeviceLayout } from 'projects/qcloud-models/device-layout';
import { LayoutType } from 'projects/qcloud-models/device/layout-type.enum';
import { DeviceLayoutService } from 'projects/qcloud-rest-client/src/lib/device-layout.service';

@Component({
  selector: 'app-device-layouts',
  templateUrl: './device-layouts.component.html',
  styleUrls: ['./device-layouts.component.css']
})
export class DeviceLayoutsComponent implements OnInit {
  public deviceLayouts: DeviceLayout[];
  constructor(private deviceLayoutservice: DeviceLayoutService,
    private translate: TranslateService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getDevicesLayouts();
  }

  getLayoutName(key: number) {
    return LayoutType[key];
  }

  getDevicesLayouts() {
    this.deviceLayoutservice.getDeviceLayouts().subscribe((data) => {
      this.deviceLayouts = data;
    }, () => { })
  }

  onSubmit() {
    this.deviceLayoutservice.saveDeviceLayouts(this.deviceLayouts).subscribe(() => {
      this.translate.get('save-success').subscribe((res: string) => {
        this.toastr.success(res);
      });
    }, () => {
      this.translate.get('save-error').subscribe((error: string) => {
        this.translate.get('repeat').subscribe((res: string) => {
          this.toastr.error(res, error);
        });
      });
    })
  }
}

